import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import pxToRem from 'styles/pxToRem';
import pxToEm from 'styles/pxToEm';

const styles = theme => ({
  root: {
    position: 'relative',
    fontSize: pxToRem(14),
    lineHeight: pxToEm(16, 14),
    height: pxToEm(16, 14),
    paddingTop: 9,
    paddingRight: 10,
    paddingBottom: 10,
    whiteSpace: 'nowrap',
    '&:after': {
      content: '""',
      display: 'block',
      position: 'absolute',
      height: 24,
      width: 1,
      top: '50%',
      right: 0,
      transform: 'translateY(-50%)',
      backgroundColor: theme.palette.primary.A100,
    },
  },
});

const TextFieldAdornmentText = ({ classes, className, children }) => (
  <Typography className={classNames(classes.root, className)}>
    {children}
  </Typography>
);

TextFieldAdornmentText.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};

TextFieldAdornmentText.defaultProps = {
  className: '',
};

export default withStyles(styles)(TextFieldAdornmentText);



// WEBPACK FOOTER //
// ./src/components/fields/TextField/TextFieldAdornmentText.js